import * as React from "react";
import { forwardRef } from "react";
const SvgInputPasswordOpenEye = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 12, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#9EA1AC", d: "M.072 6.372a1 1 0 0 1 0-.743C.163 5.4 2.382 0 7.98 0s7.821 5.4 7.908 5.629a1 1 0 0 1 0 .743C15.8 6.6 13.577 12 7.98 12S.163 6.6.072 6.372M2.1 6c.54 1.066 2.344 4 5.881 4 3.518 0 5.342-2.947 5.882-4-.539-1.064-2.343-4-5.882-4-3.519 0-5.344 2.948-5.88 4m2.892 0a2.99 2.99 0 1 1 5.98.02A2.99 2.99 0 0 1 4.992 6" }));
const ForwardRef = forwardRef(SvgInputPasswordOpenEye);
export { ForwardRef as ReactComponent };
